let audioCtx = null;
let enabled = true;
let volume = 0.15;

function getCtx() {
  if (!audioCtx) audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  return audioCtx;
}

export function playSOSAlert() {
  if (!enabled) return;
  try {
    const ctx = getCtx();
    // Two-tone command center alert
    const t = ctx.currentTime;
    [523.25, 659.25].forEach((freq, i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.frequency.value = freq;
      osc.type = "sine";
      const start = t + i * 0.12;
      gain.gain.setValueAtTime(volume, start);
      gain.gain.exponentialRampToValueAtTime(0.001, start + 0.18);
      osc.start(start);
      osc.stop(start + 0.2);
    });
  } catch {}
}

export function setSoundEnabled(val) { enabled = val; }
export function setSoundVolume(val) { volume = Math.max(0, Math.min(1, val)); }
export function isSoundEnabled() { return enabled; }
